import { Symbol } from './context'
export default function symbol(value) {
  return Symbol(value)
}
